import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { connect } from 'react-redux';

import { closeActivityForm, saveActivity } from '../../store/modules/activity';
import mergeStates from '../../helpers/mergeStates';

import { dateFormatLong } from '../../helpers/formats';
import parseTime from '../../helpers/parseTime';
import Modal from './Components/Modal';
import Embed from './Components/Embed';
import { getCommunicationTypeDetails } from '../../models/Activity';

require('moment/locale/de');

const _ = require('lodash');

const mapActionCreators = {
  saveActivity,
  closeActivityForm,
};

const mapStateToProps = state => ({
  activity: state.activity.activities[state.activity.formTarget],
  tasks: _.pick(
    state.task.tasks,
    state.activity.activities[state.activity.formTarget]
      ? state.activity.activities[state.activity.formTarget].tasks
      : null,
  ),
  files: _.filter(
    _.pick(
      state.file.files,
      state.activity.activities[state.activity.formTarget]
        ? state.activity.activities[state.activity.formTarget].files
        : {},
    ),
    ['deleted_at', null],
  ),
  draft: state.activity.draft,
  open: state.activity.formOpen,
  formTarget: state.activity.formTarget,
  currentStaffId: state.login.user.currentStaffId,
  simplAccount: state.login.simplAccount,
});

const initialState = {
  start_time: moment().format('YYYY-MM-DD'),
  end_time: null,
  start_time_date_submit: moment().format('YYYY-MM-DD'),
  start_time_time_submit: moment().format('HH:mm'),
  end_time_date_submit: moment().format('YYYY-MM-DD'),
  end_time_time_submit: moment().format('HH:mm'),
  responsible_user: null,
  end_date_manual: false,
  notes: '',
  editing: false,
  loadedActivity: false,
  id: null,
  title: '',
  tasks: [],
  person_ids: [],
  persons: [],
  staff: [],
  files: [],
  companies: [],
  project_id: null,
  company_id: null,
  creator_id: null,
  communication_type: 'none',
  communication_direction: null,
  commIn: 'eingehend',
  commOut: 'ausgehend',
  personsRaw: null,
  companiesRaw: null,
  service_type_id: null,
  lastSync: null,
  type: 'modal',
  open: false, // this is rather a focused type, refers to expandable forms
};

class FormActivity extends React.Component {
  constructor(props) {
    super(props);
    const responsibleUser =
      props.currentStaffId.length === 0 ? null : props.currentStaffId;

    const personIds = [];
    if (typeof props.activity !== 'undefined') {
      props.activity.staff.forEach(element => {
        personIds.push(`staff[${element}]`);
      });
      props.activity.persons.forEach(element => {
        personIds.push(`person[${element}]`);
      });
    }

    // const companyIds = [];
    // if (typeof props.activity !== 'undefined') {
    // props.activity.staff.forEach(element => {
    //   personIds.push(`staff[${element}]`);
    // });
    // props.activity.persons.forEach(element => {
    //   personIds.push(`person[${element}]`);
    // });
    // }

    this.state = {
      ...initialState,
      responsible_user: responsibleUser,
      person_ids: personIds,
      type: props.type,
    };

    this.receivedProps = false;
    moment.locale('de');

    this.syncTimer = null;
    this.lastSync = null;
  }

  componentWillReceiveProps(nextProps) {
    // form wasnt open but now is, for example after clicking "view all fields" on dashboard
    if (this.props.open === false && nextProps.open === true) {
      this.refreshSyncTimer();

      const personIds = [];

      if (window.simplPreselection.company !== null) {
        this.setState({
          company_id: window.simplPreselection.company,
        });
        window.simplPreselection.company = null;
      }

      if (window.simplPreselection.project !== null) {
        this.setState({
          project_id: window.simplPreselection.project,
        });
        window.simplPreselection.project = null;
      }

      if (window.simplPreselection.staff !== null) {
        this.setState({
          staff: [window.simplPreselection.staff],
        });
        personIds.push(`staff[${window.simplPreselection.staff}]`);
        window.simplPreselection.staff = null;
      }

      if (window.simplPreselection.person !== null) {
        this.setState({
          persons: [window.simplPreselection.person],
        });
        personIds.push(`person[${window.simplPreselection.person}]`);
        window.simplPreselection.person = null;
      }

      this.setState({
        start_time: moment().format('YYYY-MM-DD'),
        end_time: null,
        start_time_date_submit: moment().format('YYYY-MM-DD'),
        start_time_time_submit: moment().format('HH:mm'),
        end_time_date_submit: moment().format('YYYY-MM-DD'),
        end_time_time_submit: moment().format('HH:mm'),
      });

      if (typeof nextProps.activity !== 'undefined') {
        nextProps.activity.staff.forEach(element => {
          personIds.push(`staff[${element}]`);
        });

        nextProps.activity.persons.forEach(element => {
          personIds.push(`person[${element}]`);
        });
      }

      this.setState({
        person_ids: personIds,
      });

      if (
        typeof nextProps.draft !== 'undefined' &&
        Object.keys(nextProps.draft).length
      ) {
        this.setState(nextProps.draft);

        if (
          typeof nextProps.draft.personsRaw !== 'undefined' &&
          nextProps.draft.personsRaw !== null &&
          nextProps.draft.personsRaw.length
        ) {
          this.setState({
            personsRaw: nextProps.draft.personsRaw,
            person_ids: nextProps.draft.person_ids,
          });
        }
      }
    }

    if (this.state.responsible_user === null) {
      if (nextProps.currentStaffId.length !== 0) {
        this.setState({ responsible_user: nextProps.currentStaffId });
      }
    }

    if (
      typeof nextProps.formTarget !== 'undefined' &&
      nextProps.formTarget !== null &&
      this.receivedProps === false
    ) {
      if (
        typeof nextProps.activity !== 'undefined' &&
        nextProps.activity !== null
      ) {
        this.setState(_.omit(nextProps.activity, ['tasks', 'files']));

        this.selectCommunicationType(nextProps.activity.communication_type);

        const start = moment(nextProps.activity.start_time);

        if (start.isValid()) {
          this.setState({
            start_time: start.format('YYYY-MM-DD'),
            start_time_date_submit: start.format('YYYY-MM-DD'),
            start_time_time_submit: start.format('HH:mm'),
          });
        }

        const end = moment(nextProps.activity.end_time);

        if (end.isValid()) {
          this.setState({
            end_time: end.format('YYYY-MM-DD'),
            end_time_date_submit: end.format('YYYY-MM-DD'),
            end_time_time_submit: end.format('HH:mm'),
          });
        }

        if (nextProps.activity.end_time !== null) {
          this.setState({
            end_date_manual: true,
          });
        }

        this.setState({
          notes: nextProps.activity.notes,
        });

        this.receivedProps = true;
      }
    }

    if (this.state.tasks.length === 0) {
      if (nextProps.tasks !== null) {
        if (Object.keys(nextProps.tasks).length) {
          const tasks = [];
          _.forOwn(nextProps.tasks, task => {
            const receivedTask = task;
            receivedTask.editing = false;
            tasks.push(receivedTask);
          });

          this.setState({ tasks });
        }
      }
    }

    if (this.state.files.length === 0) {
      this.setState({
        files: Object.keys(nextProps.files).map(key => nextProps.files[key]),
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextState) !== JSON.stringify(this.state)) {
      return true;
    }

    if (
      JSON.stringify(
        _.omit(nextProps, ['saveActivity', 'closeActivityForm']),
      ) !==
      JSON.stringify(_.omit(this.props, ['saveActivity', 'closeActivityForm']))
    ) {
      return true;
    }

    return false;
  }

  resetState = () => {
    this.setState({
      ...initialState,
      responsible_user: this.props.currentStaffId,
      type: this.props.originalType,
    });

    if (this.syncTimer !== null) {
      clearTimeout(this.syncTimer);
    }

    this.receivedProps = false;
  };

  closeActivity = () => {
    this.setState({
      type: this.props.originalType,
    });

    this.props.closeActivityForm();
  };

  save = () => {
    this.props.saveActivity(this.state);
    this.resetState();
    this.closeActivity();
  };

  syncActivity = () => {
    const preparedActivity = _.omit(this.state, [
      'persons',
      'staff',
      'person_ids',
      'tasks',
      'companies',
      'companiesRaw',
    ]);

    if (preparedActivity.notes === null) {
      return;
    }

    if (
      preparedActivity.notes.length === 0 &&
      preparedActivity.title.length === 0
    ) {
      // probably nothing to save, aborting
      return;
    }

    if (preparedActivity.title.length === 0) {
      // set a title for the autosave since the user didn't put one in yet
      preparedActivity.title = `Automatische Speicherung · ${moment().format(
        dateFormatLong,
      )}`;
    }

    preparedActivity.autoSync = true;

    preparedActivity.simplAccount = this.props.simplAccount;

    this.setState({ lastSync: moment() });

    this.props.saveActivity(preparedActivity, false).then(json => {
      this.setState({
        id: json.id,
      });

      if (this.state.title.length === 0) {
        this.setState({
          title: json.title,
        });
      }
    });
  };

  refreshSyncTimer = () => {
    if (this.syncTimer !== null) {
      clearTimeout(this.syncTimer);
    }

    this.syncTimer = setTimeout(this.syncActivity, 10000);
  };

  handleChange = e => {
    const nextState = mergeStates(e, this.state);
    this.setState(nextState);

    this.refreshSyncTimer();
  };

  handleTimeChange = e => {
    const val = e.target.value;
    const name = e.target.name;

    const newData = {};
    newData[name] = parseTime(val);

    this.setState(newData);
  };

  selectCommunicationType = val => {
    const communicationName = typeof val !== 'string' ? val.value : val;

    const communicationType = getCommunicationTypeDetails(communicationName);

    this.setState({
      communication_type: communicationName,
      commIn: communicationType.in,
      commOut: communicationType.out,
    });

    this.refreshSyncTimer();
  };

  personPicked = e => {
    this.setState({
      person_ids: e.target.value,
      personsRaw: e.target.rawValue,
    });
  };

  companiesPicked = e => {
    this.setState({
      companies: e.target.value,
      companiesRaw: e.target.rawValue,
    });
  };

  render() {
    if (this.state.type === 'modal') {
      return (
        <Modal
          activity={this.state}
          save={this.save}
          open={this.props.open || this.state.open}
          setState={obj => this.setState(obj)}
          resetState={this.resetState}
          closeActivityForm={this.closeActivity}
          handleChange={this.handleChange}
          handleTimeChange={this.handleTimeChange}
          personPicked={this.personPicked}
          companiesPicked={this.companiesPicked}
          selectCommunicationType={this.selectCommunicationType}
        />
      );
    } else if (this.state.type === 'embed') {
      return (
        <Embed
          activity={this.state}
          save={this.save}
          open={this.state.open}
          setState={obj => this.setState(obj)}
          resetState={this.resetState}
          closeActivityForm={this.closeActivity}
          handleChange={this.handleChange}
          handleTimeChange={this.handleTimeChange}
          personPicked={this.personPicked}
          companiesPicked={this.companiesPicked}
          selectCommunicationType={this.selectCommunicationType}
          sidebar={this.props.sidebar}
          todayWidget={this.props.todayWidget}
        />
      );
    }

    return null;
  }
}
FormActivity.propTypes = {
  type: PropTypes.string,
  originalType: PropTypes.string,
  saveActivity: PropTypes.func.isRequired,
  closeActivityForm: PropTypes.func.isRequired,
  currentStaffId: PropTypes.string.isRequired,
  simplAccount: PropTypes.string.isRequired,
  activity: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  tasks: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  files: PropTypes.oneOfType([
    // eslint-disable-line react/no-unused-prop-types
    PropTypes.object,
    PropTypes.array,
  ]), // eslint-disable-line react/no-unused-prop-types
  draft: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  open: PropTypes.bool,
  sidebar: PropTypes.bool,
  todayWidget: PropTypes.bool,
  formTarget: PropTypes.oneOfType([
    // eslint-disable-line react/no-unused-prop-types
    PropTypes.string,
    PropTypes.number,
  ]),
};

FormActivity.defaultProps = {
  currentStaffId: '',
  type: 'modal',
  originalType: 'modal',
  sidebar: false,
  todayWidget: false,
};

export default connect(mapStateToProps, mapActionCreators)(FormActivity);



// WEBPACK FOOTER //
// ./src/components/FormActivity/FormActivity.js